import { Heading, SecondaryText, StyledFlex, StyledMargin } from '@dreryk/react-components';

import { aiAssistantSettingsPanelTranslationKeys } from '../translations';

import { AiAssistantSettingsForm } from './form/AiAssistantSettingsForm';
import { formInitializer } from './form/AiAssistantSettingsForm.utils';
import { AiAssistantSettingsPanelLoader } from './AiAssistantSettingsPanel.loader';
import { StyledHr } from './AiAssistantSettingsPanel.styled';
import { AiAssistantPlanSection } from './AiAssistantPlanSection';

const t = aiAssistantSettingsPanelTranslationKeys;

export const AiAssistantSettingsPanel = (): JSX.Element => {
   return (
      <AiAssistantSettingsPanelLoader>
         {({ budgetSummary, effectiveEnabled, enabledByProvider, tokenPackages }) => (
            <>
               <StyledFlex direction={'column'} gap={'16px'}>
                  <AiAssistantSettingsForm
                     initializer={formInitializer(enabledByProvider)}
                     locked={!effectiveEnabled}
                  />
               </StyledFlex>

               <StyledHr />
               <StyledFlex direction={'column'} gap={'16px'}>
                  <StyledFlex direction={'column'}>
                     <Heading content={t.header} type={'h2'} testId={'aiAssistantSettingsHeader'} margin={'0px'} />
                     <SecondaryText testId={'aiAssistantSettingsDescription'} text={t.description} />
                  </StyledFlex>

                  <StyledMargin right={50}>
                     <AiAssistantPlanSection budgetSummary={budgetSummary} tokenPackages={tokenPackages} />
                  </StyledMargin>
               </StyledFlex>
            </>
         )}
      </AiAssistantSettingsPanelLoader>
   );
};
